(() => {
  const initSlideshows = (scope = document) => {
    scope.querySelectorAll?.('[data-flex-slideshow]').forEach((root) => {
      if (root.dataset.bound === '1') return;
      root.dataset.bound = '1';
      const slides = [...root.querySelectorAll('[data-flex-slide]')];
      const dots = [...root.querySelectorAll('[data-flex-dot]')];
      const prev = root.querySelector('[data-flex-prev]');
      const next = root.querySelector('[data-flex-next]');
      if (!slides.length) return;
      let index = Math.max(0, slides.findIndex(s => s.classList.contains('is-active')));
      let timer;
      let editorSelected = false;
      let hovering = false;
      let paused = false;
      let focused = false;
      let touchStartX = 0;
      let touchStartY = 0;
      const autoplay = root.dataset.autoplay === 'true';
      const duration = Math.max(2000, parseInt(root.dataset.duration || '5000', 10));
      const swipeMobile = root.dataset.swipeMobile !== 'false';
      const show = (n) => {
        index = (n + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.inert = !active;
        });
        dots.forEach((dot, i) => {
          const active = i === index;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
        });
      };
      const stop = () => { if (timer) clearTimeout(timer); timer = undefined; };
      const startTimer = () => {
        stop();
        if (autoplay && slides.length > 1 && !editorSelected && !paused && !focused && !hovering && !document.hidden && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          const slideDuration = parseInt(slides[index].dataset.duration || '0', 10);
          timer = setTimeout(() => { show(index + 1); startTimer(); }, slideDuration > 0 ? Math.max(1000, slideDuration) : duration);
        }
      };
      root.querySelector('[data-flex-pause]')?.addEventListener('click', (event) => {
        paused = !paused;
        event.currentTarget.setAttribute('aria-pressed', String(paused));
        event.currentTarget.textContent = paused ? 'Lecture' : 'Pause';
        event.currentTarget.setAttribute('aria-label', paused ? 'Reprendre le diaporama' : 'Mettre le diaporama en pause');
        if (paused) stop(); else startTimer();
      });
      root.addEventListener('focusin', () => { focused = true; stop(); });
      root.addEventListener('focusout', event => { if (!root.contains(event.relatedTarget)) { focused = false; startTimer(); } });
      prev?.addEventListener('click', () => { show(index - 1); startTimer(); });
      next?.addEventListener('click', () => { show(index + 1); startTimer(); });
      dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); startTimer(); }));
      if (root.dataset.pauseHover === 'true') {
        root.addEventListener('mouseenter', () => { hovering = true; stop(); });
        root.addEventListener('mouseleave', () => { hovering = false; startTimer(); });
      }
      if (swipeMobile) {
        root.addEventListener('touchstart', (event) => {
          const touch = event.touches[0];
          touchStartX = touch.clientX;
          touchStartY = touch.clientY;
        }, { passive: true });
        root.addEventListener('touchend', (event) => {
          const touch = event.changedTouches[0];
          const dx = touch.clientX - touchStartX;
          const dy = touch.clientY - touchStartY;
          if (Math.abs(dx) > 42 && Math.abs(dx) > Math.abs(dy) * 1.15) {
            show(index + (dx < 0 ? 1 : -1));
            startTimer();
          }
        }, { passive: true });
      }
      const onVisibility = () => document.hidden ? stop() : startTimer();
      const onUnload = (event) => {
        if (!event.target.contains(root)) return;
        stop();
        document.removeEventListener('visibilitychange', onVisibility);
        document.removeEventListener('shopify:section:unload', onUnload);
      };
      document.addEventListener('visibilitychange', onVisibility);
      document.addEventListener('shopify:section:unload', onUnload);
      root.addEventListener('shopify:block:select', (event) => {
        const slide = event.target.closest('[data-flex-slide]');
        const selected = slides.indexOf(slide);
        if (selected < 0) return;
        editorSelected = true;
        stop();
        show(selected);
      });
      root.addEventListener('shopify:block:deselect', () => { editorSelected = false; startTimer(); });
      show(index);
      startTimer();
    });
  };

  const initTabs = (scope = document) => {
    scope.querySelectorAll?.('[data-flex-tabs]').forEach((root) => {
      if (root.dataset.bound === '1') return; root.dataset.bound='1';
      const buttons=[...root.querySelectorAll('[data-flex-tab]')]; const panels=[...root.querySelectorAll('[data-flex-panel]')];
      buttons.forEach((btn,i)=>btn.addEventListener('click',()=>{buttons.forEach((b,j)=>{b.classList.toggle('is-active',j===i);b.setAttribute('aria-selected',j===i?'true':'false')});panels.forEach((p,j)=>p.classList.toggle('is-active',j===i));}));
    });
  };

  const initBeforeAfter = (scope = document) => {
    scope.querySelectorAll?.('[data-before-after]').forEach((root)=>{
      if(root.dataset.bound==='1')return; root.dataset.bound='1'; const input=root.querySelector('input[type=range]'); if(!input)return;
      const sync=()=>root.style.setProperty('--pos',`${input.value}%`); input.addEventListener('input',sync); sync();
    });
  };

  const initReveal = (scope = document) => {
    if (!document.body.classList.contains('has-reveal')) return;
    const els=[...scope.querySelectorAll?.('.flex-section[data-reveal]:not(.is-revealed)')||[]];
    if (!('IntersectionObserver' in window)) { els.forEach(el=>el.classList.add('is-revealed')); return; }
    const io=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-revealed');io.unobserve(entry.target)}}),{threshold:.08}); els.forEach(el=>io.observe(el));
  };

  const init = (scope=document) => { initSlideshows(scope); initTabs(scope); initBeforeAfter(scope); initReveal(scope); };
  init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
